import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

const CardPlayerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: ${({ theme }) => `${utils.rem(theme.Spacing.Size.XSmall)}`};
  width: ${({ theme }) => `${utils.rem(theme.Spacing.Size.MediumLarge)}`};
  height: ${({ theme }) => `${utils.rem(theme.Spacing.Size.MediumLarge)}`};
  transition: opacity 0.5s ease-in-out;
`;

export const CardPlayerStyles = {
  CardPlayerWrapper,
};
